import Button from "../../atoms/Button";
import { Link } from "react-router-dom";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { SideBarLabels } from "../../../utils/labels/sidebarLabels";
import { sideNav } from "../../../utils/API/sideNav";
import { getAuthToken } from "../../../utils/helper/token";
import Loader from "./Loader";
import { useState } from "react";
import { useEffect } from "react";
import NavButton from "./NavButton";
import { postApi } from "../../../utils/API/api_instance";

const SideBar = () => {
  const dispatch = useDispatch();
  let {
    Logo,
    signupText,
    TnC1,
    TnC2,
    botHead,
    botSubHead,
    botButton,
    switchButton,
    switchSubHead,
  } = SideBarLabels;
  const { isAuth } = useSelector((state) => state.authReducer);
  const [sideNavData, setSideNavData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      try {
        const data = await sideNav(dispatch);
        setSideNavData(data);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [isAuth]);

  const handleSwitchTo = async () => {
    try {
      // console.log("Ddd")
      const response = await postApi({
        apiUrl: `/api/user/create-switch-request`,
        sendToken: true,
        dispatch,
        data: {},
      });

      if (response.success) {
        let url = ` ${process.env.REACT_CARBON_CALCULATOR_URL || "http://localhost:3000"}/switch/${response.data}`;
        window.open(url, "_blank");
        // dispatch(loginAsEmployee());
        // toast.success(response.message);
        // navigate("/dashboard");
      }
    } catch (error) {
      // toast.error(
      //   "Login failed. Please check your credentials and try again."
      // );
      // navigate("/login");
    }
  };
  return (
    <>
      <aside className=" top-0 left-0 w-[198px] h-full ">
        <div className="h-full w-auto px-3 py-4">
          <Link
            to=""
            className="relative flex items-center mt-[2.375rem] ml-[1.7rem] mb-5 z-10"
          >
            {Logo}
          </Link>
          {isLoading ? (
            <Loader />
          ) : (
            <ul className="space-y-2 mt-10 ml-[1rem] font-normal leading-5 text-base">
              {sideNavData.map(({ title, svgPath, redirectRoute }, index) => (
                <NavButton
                  key={`navbutton${index}`}
                  title={title}
                  svgPath={svgPath}
                  redirectRoute={redirectRoute}
                />
              ))}
            </ul>
          )}
          <div className="mt-7 ml-[1rem]">
            {!isAuth && (
              <Link to={"/user-portal"}>
                <Button
                  varient="primary"
                  borderColor="black"
                  color="blue"
                  className="text-sm justify-center px-6 py-2 text-white"
                >
                  {signupText}
                </Button>
              </Link>
            )}
          </div>
          <div className="w-40 font-medium leading-4 mt-4 ml-[1rem]">
            <p className="text-[10px] text-center ">
              Please Read our
              <Link to="/terms">
                {" "}
                <span className="text-[10px] text-blue-800"> {TnC1}</span>
              </Link>
              and
              <Link to="/privacy">
                <span className="text-[10px] text-blue-800"> {TnC2}</span>
              </Link>
            </p>
          </div>
          {/* <div className="w-40 h-32 mx-1 mb-3 text-center rounded-3xl bg-blue-200">
            <h1 className=" pt-6 mt-20">{botHead}</h1>
            <Link to="/contact-us">
              <Button
                varient="rounded"
                borderColor="black"
                color="blue"
                className="text-xs justify-center  px-7 py-2 mt-3 text-white"
              >
                {botButton}
              </Button>
            </Link>
          </div> */}
          <div className="w-40 h-32 mx-1 mb-3 text-center rounded-3xl bg-blue-200">
            <h2 className=" pt-6 mt-20">{switchSubHead}</h2>
            {/* <p className="text-xs text-grey-800">{botSubHead}</p> */}

            <Button
              varient="rounded"
              borderColor="black"
              color="blue"
              className="text-xs justify-center  px-7 py-2 mt-3 text-white"
              onClick={handleSwitchTo}
            >
              {switchButton}
            </Button>
          </div>
          <hr />
        </div>
      </aside>
    </>
  );
};
export default SideBar;
